// extracted by mini-css-extract-plugin
export default {"sortingTable":"SortingTable_sortingTable__CQizy","reorderButtons":"SortingTable_reorderButtons__4ZX8i","deleteButton":"SortingTable_deleteButton__NKZ+B"};